import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { ResponseStatus } from '../../shared';
import { ServiceItemService } from '../service-item.service';
import * as ServiceItemActions from './service-item.actions';
import * as fromStore from './service-item.reducer';

@Injectable()
export class ServiceItemEffects {
    getServiceItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ServiceItemActions.getServiceItems),
            switchMap(a =>
                this.service.get().pipe(
                    concatMap(resp => [
                        ServiceItemActions.loadServiceItems({
                            serviceItems: resp.map(item => ({
                                ...item,
                                id: item.SIListID
                            }))
                        }),
                        new fromShared.Errors.SetErrors(
                            fromShared.Errors.MapItemsToStatus(resp)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    postServiceItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ServiceItemActions.postServiceItems),
            switchMap(action =>
                this.service.post(action.SIListIds).pipe(
                    concatMap(resp => [
                        ServiceItemActions.loadServiceItems({
                            serviceItems: resp.map(item => ({
                                ...item,
                                id: item.SIListID
                            }))
                        }),
                        new fromShared.Errors.SetErrors(
                            fromShared.Errors.MapItemsToStatus(resp)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    putServiceItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ServiceItemActions.putServiceItems),
            switchMap(a =>
                this.service.put(a.items).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  ServiceItemActions.upsertServiceItems({
                                      serviceItems: resp.Items
                                  }),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.SIListID.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  ServiceItemActions.upsertServiceItems({
                                      serviceItems: resp.Items
                                  })
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    getServiceItemPostingTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ServiceItemActions.getServiceItemPostingTypes),
            // withLatestFrom(
            //     this.store.pipe(
            //         select(fromSelectors.selectServiceItemPostingTypes)
            //     )
            // ),
            // filter(([action, items]) => !items || items.length === 0),
            switchMap(() =>
                this.service.getServiceItemPostingTypes().pipe(
                    map(resp =>
                        ServiceItemActions.loadServiceItemPostingTypes({
                            ServiceItemPostingTypes: resp
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    constructor(
        private actions$: Actions,
        private service: ServiceItemService,
        private store: Store<fromStore.State>
    ) {}
}
